import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { CreateManagerSalaryDto } from '../types';
import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';

type Params = {
  managerId: number;
  year: number;
  month: number;
  bonus: string;
  salary: string;
  additionalBonus: string;
  penalty: string;
}

const createManagerSalary = async ({
  managerId,
  year,
  month,
  bonus,
  salary,
  additionalBonus,
  penalty,
}: Params): Promise<void> => {
  const body: CreateManagerSalaryDto = {
    manager: managerId,
    salary,
    month,
    year,
    bonus,
    penalty,
    addinional_bonus: additionalBonus,
  };

  await api.post(
    `${PANEl_BASE_URL}/manager-salaries/manager-salaries/`,
    body
  );
};

export const useCreateManagerSalary = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: createManagerSalary,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};